import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-alert-card',
  templateUrl: './alert-card.component.html',
  styleUrls: ['./alert-card.component.scss'],
})
export class AlertCardComponent {
  @Input() msg: string = '';
  @Input() state: string = '';
  @Input() link: string = '';
  @Input() buttonText: string = '';
  constructor() {}
}
